<template>
    <span>
        <svg v-if="icon === 'symbols'" style="position: absolute; width: 0; height: 0;" width="0" height="0" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <defs>
                <symbol id="icon-more" viewBox="0 0 12 8">
                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g transform="translate(-1060.000000, -47.000000)">
                            <g transform="translate(1054.000000, 39.000000)">
                                <polygon fill="currentColor" fill-rule="nonzero" points="16.59 8.59 12 13.17 7.41 8.59 6 10 12 16 18 10"></polygon>
                                <polygon points="0 0 24 0 24 24 0 24"></polygon>
                            </g>
                        </g>
                    </g>
                </symbol>
            </defs>
        </svg>
        <svg v-else-if="icon === 'hamburger'" id="hamburger" width="42px" height="42px" viewBox="0 0 42 42" xmlns="http://www.w3.org/2000/svg">
            <path style="opacity:0.251;fill:none;stroke:#FFFFFF;stroke-width:1.5;" d="M21,0.8c1.3,0,2.6,0.1,4,0.4
                s2.6,0.6,3.8,1.2c1.2,0.5,2.4,1.1,3.5,1.9c1.1,0.7,2.1,1.6,3.1,2.5c0.9,0.9,1.8,2,2.5,3.1c0.7,1.1,1.4,2.3,1.9,3.5
                c0.5,1.2,0.9,2.5,1.2,3.8c0.3,1.3,0.4,2.6,0.4,4s-0.1,2.6-0.4,4c-0.3,1.3-0.6,2.6-1.2,3.8s-1.1,2.4-1.9,3.5
                c-0.7,1.1-1.6,2.1-2.5,3.1c-0.9,0.9-2,1.8-3.1,2.5c-1.1,0.7-2.3,1.4-3.5,1.9s-2.5,0.9-3.8,1.2c-1.3,0.3-2.6,0.4-4,0.4
                s-2.6-0.1-4-0.4c-1.3-0.3-2.6-0.6-3.8-1.2s-2.4-1.1-3.5-1.9s-2.1-1.6-3.1-2.5c-0.9-0.9-1.8-2-2.5-3.1c-0.7-1.1-1.4-2.3-1.9-3.5
                S1.4,26.3,1.1,25c-0.3-1.3-0.4-2.6-0.4-4s0.1-2.6,0.4-4c0.3-1.3,0.6-2.6,1.2-3.8c0.5-1.2,1.1-2.4,1.9-3.5c0.7-1.1,1.6-2.1,2.5-3.1
                c0.9-0.9,2-1.8,3.1-2.5s2.3-1.4,3.5-1.9c1.2-0.5,2.5-0.9,3.8-1.2S19.7,0.8,21,0.8z"/>                    
            <line style="fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-miterlimit:10;" x1="15" y1="17" x2="26.3" y2="17"/>
            <line style="fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-miterlimit:10;" x1="15" y1="21.5" x2="26.3" y2="21.5"/>
            <line style="fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-miterlimit:10;" x1="15" y1="26" x2="26.3" y2="26"/>
        </svg>
        <svg v-else-if="icon === 'heart-solid'" id="heart" width="42px" height="42px" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
            <path fill="currentColor" d="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"></path>
        </svg>
        <svg v-else-if="icon === 'heart-outline'" id="heart" width="42px" height="42px" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
            <path fill="currentColor" d="M458.4 64.3C400.6 15.7 311.3 23 256 79.3 200.7 23 111.4 15.6 53.6 64.3-21.6 127.6-10.6 230.8 43 285.5l175.4 178.7c10 10.2 23.4 15.9 37.6 15.9 14.3 0 27.6-5.6 37.6-15.8L469 285.6c53.5-54.7 64.7-157.9-10.6-221.3zm-23.6 187.5L259.4 430.5c-2.4 2.4-4.4 2.4-6.8 0L77.2 251.8c-36.5-37.2-43.9-107.6 7.3-150.7 38.9-32.7 98.9-27.8 136.5 10.5l35 35.7 35-35.7c37.8-38.5 97.8-43.2 136.5-10.6 51.1 43.1 43.5 113.9 7.3 150.8z"></path>
        </svg>
    </span>
</template>

<script>
export default {
    props: {
        icon: {
            type: String,
            required: true,
        }
    }
};
</script>
